import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
export interface GenericModalOptions {
  modalText: string;
  modalHeader: string;
  cancelOption: string;
  approveOption: string;
  onlyApprove: boolean;
  customTextStyle?: { [p: string]: string };
}

@Component({
  selector: "generic-app-modal",
  templateUrl: "./generic-modal.component.html",
  styleUrls: ["./generic-modal.component.scss"],
})
export class GenericModalComponent implements OnInit {
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public modalText: string = "האם את.ה בטוח רוצה למחוק?";
  public modalHeader: string = "אישור מחיקה";
  public approveOption?: string = "אישור";
  public cancelOption?: string = "ביטול";
  public data: any = null;
  public customTextStyle: { [p: string]: string } = {};

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  @Input("modalOptions") set modalOptions(options: GenericModalOptions) {
    this.modalText = options.modalText;
    this.modalHeader = options.modalHeader;
    this.approveOption = options.approveOption || this.approveOption;
    this.cancelOption = options.approveOption || this.cancelOption;
    // tslint:disable-next-line:no-object-literal-type-assertion
    this.customTextStyle = options.customTextStyle || {
      "white-space": "pre-wrap",
    };
    if (options.onlyApprove) {
      this.cancelOption = "";
    }
  }

  public ngOnInit(): void {}

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/generic-app-modal/generic-modal.component.ts